// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"f0bd9218","147":"623df1ef","239":"e39fb35b","277":"9e994d05","305":"5c113508","344":"fc577526","455":"65403f5e","518":"18537140","580":"db164cbc","914":"90e9c541","977":"240addac"}[chunkId] + ".chunk.js";
};